export const LAYOUT_CONFIG = {
  headerHeight: 70,
  horizontalMenuHeight: 40,
  drawerWidth: 240,
  collapsedWidth: 70,
  transition: 'all 0.2s ease',
} as const;

// Pages that fill the whole area under the header (their own layout handles scrolling): the main area
// must not reserve a scrollbar gutter for them, or a blank strip stays on the right edge.
export const FULL_WIDTH_ROUTE_PREFIXES = ['/marketing/new-campaign', '/marketing/campaigns/'] as const;

export type LayoutMode = 'vertical' | 'horizontal';
